import React from 'react';
import { useTranslation } from 'react-i18next';
import { User } from 'lucide-react';
import { UserSelectorAvatar } from '@/shared/components/user-selector/UserSelectorAvatar';
import type { FullIssueWithChildren } from '@/shared/utils/issue-guards';

interface ViewGoalAssigneesProps {
  assignees: FullIssueWithChildren['assignees'];
}

export const ViewGoalAssignees: React.FC<ViewGoalAssigneesProps> = ({
  assignees,
}) => {
  const { t } = useTranslation('goals');

  return (
    <div>
      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-2">
        <User className="h-3.5 w-3.5" />
        {t('assigneesLabel')}
      </label>
      <div className="flex flex-wrap gap-2">
        {assignees.map((assignee) => (
          <div
            key={assignee._id}
            className="flex items-center gap-2 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg"
          >
            <UserSelectorAvatar
              fullName={`${assignee.personalInfo.firstName} ${assignee.personalInfo.lastName}`}
              imageUrl={assignee.personalInfo.imageUrl}
              size="sm"
            />
            <span className="text-sm text-gray-700">
              {assignee.personalInfo.firstName} {assignee.personalInfo.lastName}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
